import { UserType } from '../../../../../../api/types/user/user-type';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';

export const addNewDocumentRequirementOperation = async (
  userRole: UserType,
  docTypeId: number,
  docName: string,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    await appApi.addUserRoleDocumentRequirement(userRole, docTypeId, docName);

    // Refresh the global settings to show the new document
    await globalSettingsStores.fetchSetting();
  } catch (error) {
    console.error('Error adding document requirement:', error);
    // You might want to show an error message to the user here
  } finally {
    setLoading(false);
  }
};
